





















































































import { ICreative } from '@/types/campaign/creatives';
import Vue, { PropType } from 'vue';
import CreativeModerationStatusPopover from './CreativeModerationStatusPopover.vue';

const MODERATION_STATUS = {
  approve: 'approve',
  reject: 'reject',
};

export default Vue.extend({
  name: 'CreativeInfo',
  components: { CreativeModerationStatusPopover },
  props: {
    creative: {
      type: Object as PropType<ICreative>,
      required: true,
    },
    moderations: {
      type: Array,
      required: false,
      default: null,
    },
  },
  computed: {
    getCreativeSize(): string {
      const { template } = this.creative;

      if (template && template.width && template.height) {
        return `${template.width} X ${template.height} px`;
      } else if (this.creative.width && this.creative.height) {
        return `${this.creative.width} X ${this.creative.height} px`;
      } else {
        return '-';
      }
    },
  },
  methods: {
    moderationColor(ssp, elementColor = 'text') {
      const status = this.moderationStatus(ssp);

      switch (status) {
        case MODERATION_STATUS.approve:
          return `${elementColor}-approve`;
        case MODERATION_STATUS.reject:
          return `${elementColor}-reject`;
        default:
          return `${elementColor}-moderation`;
      }
    },
    moderationStatus(ssp) {
      return ssp.creative_moderation?.status?.value || '';
    },
  },
  data() {
    return {
      isOpenSsp: false,
    };
  },
});
